import React from "react";
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import {
	getWinClassName,
	betGroupProp,
} from "@/modules/commonMobile";

import {
	checkBaccaratPairExists
} from "@/modules/commonPopupResultHistory";

import M22MultiTable from "./m22MultiTable";
import { IGameTableType } from "@/types/GlobalTypes";
import Portrait from "./Portrait";
import SlBet from "@/components/SlBet";

import "./index.scss";
import "./m28.scss";
import { checkPlayerBankerTie, IBaccaratWinType } from "@/modules/games/Baccarat";
import { getBasePcode } from "@/modules/gamePcode";

interface IProps extends Omit<IGameTableType, "win"> {
	win: IBaccaratWinType;
}

interface IState {
	useNewPanelInterface: boolean;
}

export default class M22 extends React.Component<IProps, IState> {
	state = { useNewPanelInterface: false }

	render() {
		const { langdata } = this.props;

		const basePcode = getBasePcode(this.props.pcode),
			gwcn = getWinClassName,
			win = this.props.win;

		// console.log("m22 win", win);

		const completeTable = basePcode === "m28" ? false : this.props.completeTable;

		//["banker", "player", "big", "small", "pair", "eitherpair", "perfectpair", "tie", "tie0", "tie1", "tie2", "tie3", "tie4", "tie5", "tie6", "tie7", "tie8", "tie9"]

		const tieBetTypes = ["150:1", "215:1", "220:1", "200:1", "120:1", "110:1", "45:1", "45:1", "80:1", "80:1"];

		let totalCards = 0;

		let split = { p: [], b: [] };
		let pairs = {
			player: false,
			banker: false,
			either: false,
			perfect: false
		};

		if (win && win.player && win.banker) {
			// Counts the total X
			const totalXArray = (win.player + win.banker).match(/x/g);
			totalCards = 6 - (totalXArray || []).length;

			split = {
				p: win.player.split("-"),
				b: win.banker.split("-")
			};

			pairs = {
				player: checkBaccaratPairExists(split.p),
				banker: checkBaccaratPairExists(split.b),
				either: pairs.player || pairs.banker,
				perfect: pairs.player && pairs.banker
			};
		}

		const checkTieWin = (
			win &&
			win.playerValue &&
			win.bankerValue &&
			win.playerValue === win.bankerValue
		);

		//Kei
		//"1.95","1.95","0.54","1.5","11","5","25","9","110","200","190","180","170","160","150","140","130","120"


		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		};

		const commonTooltipProps = {
			langStr: langdata.language_code
		};

		/*const wins = {
			
		};*/

		if (this.props.portrait)
			return (
				<Portrait
					basePcode={basePcode}

					pairs={pairs}
					checkTieWin={checkTieWin}
					tieBetTypes={tieBetTypes}
					totalCards={totalCards}

					{... this.props} />
			);

		if (!this.props.maximised)
			return (
				<M22MultiTable
					basePcode={basePcode}

					pairs={pairs}
					checkTieWin={checkTieWin}
					tieBetTypes={tieBetTypes}
					totalCards={totalCards}

					{...this.props}
				/>
			);

		const commonBetProps = {
			pcode: this.props.pcode,
			chipBase: this.props.chipBase,
			mobile: this.props.mobile,
			bets: this.props.bets,
			insertBet: this.props.insertBet,
			langStr: this.props.langdata.language_code
		};

		return (
			this.props.maximised && (
				completeTable ? (
					// DESKTOP SINGLE COMPLETE TABLE
					// Baccarat V3
					<div className={"sl-table m22 full_v3" +
						(this.state.useNewPanelInterface ? " experimental" : "")}>

						<div className="tie-label">
							{this.props.langdata["txt_tie_on"]}
						</div>

						{
							this.state.useNewPanelInterface ? (
								<div className="top">
									<SlBet {...commonBetProps}
										classes="sl-bet"

										bet="eitherpair"
										group="eitherpair"

										winStatement={pairs.either}

										betLabel={this.props.langdata["txt_either_pair"]}
										betType="5:1"
									/>

									{
										[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, idx) => {
											const betKey = `tie${item}`;

											return <SlBet {...commonBetProps}
												key={betKey}
												classes="sl-bet"

												bet={betKey}
												group={betKey}

												winStatement={checkPlayerBankerTie(win, item)}

												betLabel={item + ""}
												betType={tieBetTypes[idx]}
											/>;
										})
									}

									<SlBet {...commonBetProps}
										classes="sl-bet"

										bet="perfectpair"
										group="perfectpair"

										winStatement={pairs.perfect}

										betLabel={this.props.langdata["txt_perfect_pair"]}
										betType="25:1"
									/>
								</div>
							) : (
									<div className="top">
										<div className={"sl-bet sl-baccarat-bet-blue" + gwcn(pairs.either)}
											{...betGroupProp(this, "eitherpair", "eitherpair")}
											onClick={this.props.insertBet}>
											<div><span>{this.props.langdata["txt_either_pair"]}</span></div>
											<div className="bet-type">5:1</div>
											<Chips {...commonChipProps} betKey={`eitherpair+eitherpair`} />
											<Tooltip {...commonTooltipProps} bet={this.props.bets[`eitherpair+eitherpair`]} />
										</div>

										{
											[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, idx) => {
												const betKey = `tie${item}`;

												return <div key={item}
													className={"sl-bet sl-baccarat-bet-blue" + gwcn(checkPlayerBankerTie(win, item))}
													{...betGroupProp(this, betKey, betKey)}
													onClick={this.props.insertBet}>
													<div>{item}</div>
													<div className="bet-type">
														{tieBetTypes[idx]}
													</div>

													<Chips {...commonChipProps} betKey={`${betKey}+${betKey}`} />
													<Tooltip {...commonTooltipProps} bet={this.props.bets[`${betKey}+${betKey}`]} />
												</div>;
											})
										}

										<div className={"sl-bet sl-baccarat-bet-blue" + gwcn(pairs.perfect)}
											{...betGroupProp(this, "perfectpair", "perfectpair")}
											onClick={this.props.insertBet}>
											<div><span>{this.props.langdata["txt_perfect_pair"]}</span></div>
											<div className="bet-type">25:1</div>

											<Chips {...commonChipProps} betKey={`perfectpair+perfectpair`} />
											<Tooltip {...commonTooltipProps} bet={this.props.bets[`perfectpair+perfectpair`]} />
										</div>
									</div>
								)
						}


						{
							this.state.useNewPanelInterface ? (
								<div className="bottom">
									{
										// Left side
									}
									<SlBet {...commonBetProps}
										classes="sl-bet small"

										bet="small"
										group="small"

										winStatement={win && totalCards === 4}

										betLabel={this.props.langdata["txt_small"]}
										betType="1.5:1"
									/>

									<SlBet {...commonBetProps}
										classes="sl-bet playerpair"

										bet="playerpair"
										group="playerpair"

										winStatement={win && pairs.player}

										betLabel={this.props.langdata["txt_player_pair"]}
										betType="11:1"
									/>

									{
										// Centre
									}
									<SlBet {...commonBetProps}
										classes="sl-bet player"

										bet="player"
										group="player"

										winStatement={win && (win.playerValue > win.bankerValue)}

										betLabel={this.props.langdata["txt_player"]}
										betType="1:1"
									/>

									<SlBet {...commonBetProps}
										classes="sl-bet tie"

										bet="tie"
										group="tie"

										winStatement={checkTieWin}

										betLabel={this.props.langdata["txt_tie"]}
										betType="8:1"
									/>

									<SlBet {...commonBetProps}
										classes="sl-bet banker"

										bet="banker"
										group="banker"

										winStatement={win && (win.playerValue < win.bankerValue)}

										betLabel={this.props.langdata["txt_banker"]}
										betType="0.95:1"
									/>

									{
										// Right side
									}
									<SlBet {...commonBetProps}
										classes="sl-bet big"

										bet="big"
										group="big"

										winStatement={win && totalCards > 4}

										betLabel={this.props.langdata["txt_big"]}
										betType="0.54:1"
									/>

									<SlBet {...commonBetProps}
										classes="sl-bet bankerpair"

										bet="bankerpair"
										group="bankerpair"

										winStatement={win && pairs.banker}

										betLabel={this.props.langdata["txt_banker_pair"]}
										betType="11:1"
									/>

								</div>
							) : (
									<div className="bottom">
										<div className="sides">
											<div className={"sl-bet sl-baccarat-bet-blue" + gwcn(win && totalCards === 4)}
												{...betGroupProp(this, "small", "small")}
												onClick={this.props.insertBet}>
												<div>{this.props.langdata["txt_small"]}</div>

												<div className="bet-type">1.5:1</div>
												<Chips {...commonChipProps} betKey={`small+small`} />
												<Tooltip {...commonTooltipProps} bet={this.props.bets[`small+small`]} />
											</div>
											<div className={"sl-bet sl-baccarat-bet-blue" + gwcn(pairs.player)}
												{...betGroupProp(this, "playerpair", "playerpair")}
												onClick={this.props.insertBet}>
												<div className="baccarat-blue-text"><span>{this.props.langdata["txt_player_pair"]}</span></div>

												<div className="bet-type">11:1</div>
												<Chips {...commonChipProps} betKey={`playerpair+playerpair`} />
												<Tooltip {...commonTooltipProps} bet={this.props.bets[`playerpair+playerpair`]} />
											</div>
										</div>

										<div className="middle">
											<div className={"sl-bet bold sl-baccarat-bet-blue" + gwcn(win && (win.playerValue > win.bankerValue))}
												{...betGroupProp(this, "player", "player")}
												onClick={this.props.insertBet}>
												<div className="baccarat-blue-text">{this.props.langdata["txt_player"]}</div>

												<div className="bet-type">1:1</div>
												<Chips {...commonChipProps} betKey={`player+player`} />
												<Tooltip {...commonTooltipProps} bet={this.props.bets[`player+player`]} />
											</div>
											<div className={"sl-bet bold sl-baccarat-bet-blue" + gwcn(checkTieWin)}
												{...betGroupProp(this, "tie", "tie")}
												onClick={this.props.insertBet}>
												<div className="baccarat-green-text">{this.props.langdata["txt_tie"]}</div>

												<div className="bet-type">8:1</div>
												<Chips {...commonChipProps} betKey={`tie+tie`} />
												<Tooltip {...commonTooltipProps} bet={this.props.bets[`tie+tie`]} />
											</div>
											<div className={"sl-bet bold sl-baccarat-bet-blue" + gwcn(win && (win.playerValue < win.bankerValue))}
												{...betGroupProp(this, "banker", "banker")}
												onClick={this.props.insertBet}>
												<div className="baccarat-red-text">{this.props.langdata["txt_banker"]}</div>

												<div className="bet-type">0.95:1</div>
												<Chips {...commonChipProps} betKey={`banker+banker`} />
												<Tooltip {...commonTooltipProps} bet={this.props.bets[`banker+banker`]} />
											</div>
										</div>

										<div className="sides">
											<div className={"sl-bet sl-baccarat-bet-blue" + gwcn(win && totalCards > 4)}
												{...betGroupProp(this, "big", "big")}
												onClick={this.props.insertBet}>
												<div>{this.props.langdata["txt_big"]}</div>

												<div className="bet-type">0.54:1</div>
												<Chips {...commonChipProps} betKey={`big+big`} />
												<Tooltip {...commonTooltipProps} bet={this.props.bets[`big+big`]} />
											</div>
											<div className={"sl-bet sl-baccarat-bet-blue" + gwcn(pairs.banker)}
												{...betGroupProp(this, "bankerpair", "bankerpair")}
												onClick={this.props.insertBet}>
												<div className="baccarat-red-text"><span>{this.props.langdata["txt_banker_pair"]}</span></div>

												<div className="bet-type">11:1</div>
												<Chips {...commonChipProps} betKey={`bankerpair+bankerpair`} />
												<Tooltip {...commonTooltipProps} bet={this.props.bets[`bankerpair+bankerpair`]} />
											</div>
										</div>
									</div>
								)
						}

					</div>
				) : (
						// DESKTOP SINGLE SIMPLER TABLE
						// Baccarat V3
						<div className={"sl-table m22 simpler" +
							(this.state.useNewPanelInterface ? " experimental" : "")}>
							<div className="top">
								<div className={"sl-bet sl-baccarat-bet-blue" + gwcn(pairs.player)}
									{...betGroupProp(this, "playerpair", "playerpair")}
									onClick={this.props.insertBet}>
									<div className="baccarat-blue-text"><span>{this.props.langdata["txt_player_pair"]}</span></div>

									<div className="bet-type">11:1</div>
									<Chips {...commonChipProps} betKey={`playerpair+playerpair`} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[`playerpair+playerpair`]} />
								</div>
								<div className={"sl-bet sl-baccarat-bet-blue" + gwcn(pairs.banker)}
									{...betGroupProp(this, "bankerpair", "bankerpair")}
									onClick={this.props.insertBet}>
									<div className="baccarat-red-text"><span>{this.props.langdata["txt_banker_pair"]}</span></div>

									<div className="bet-type">11:1</div>
									<Chips {...commonChipProps} betKey={`bankerpair+bankerpair`} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[`bankerpair+bankerpair`]} />
								</div>
							</div>

							<div className="bottom">
								<div className={"sl-bet bold sl-baccarat-bet-blue" + gwcn(win && (win.playerValue > win.bankerValue))}
									{...betGroupProp(this, "player", "player")}
									onClick={this.props.insertBet}>
									<div className="baccarat-blue-text">{this.props.langdata["txt_player"]}</div>

									<div className="bet-type">
										{
											basePcode === "m28" ?
												"0.97:1" :
												"1:1"
										}
									</div>
									<Chips {...commonChipProps} betKey={`player+player`} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[`player+player`]} />
								</div>
								<div className={"sl-bet bold sl-baccarat-bet-blue" + gwcn(checkTieWin)}
									{...betGroupProp(this, "tie", "tie")}
									onClick={this.props.insertBet}>
									<div className="baccarat-green-text">{this.props.langdata["txt_tie"]}</div>

									<div className="bet-type">8:1</div>
									<Chips {...commonChipProps} betKey={`tie+tie`} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[`tie+tie`]} />
								</div>
								<div className={"sl-bet bold sl-baccarat-bet-blue" + gwcn(win && (win.playerValue < win.bankerValue))}
									{...betGroupProp(this, "banker", "banker")}
									onClick={this.props.insertBet}>
									<div className="baccarat-red-text">{this.props.langdata["txt_banker"]}</div>

									<div className="bet-type">
										{
											basePcode === "m28" ?
												"0.97:1" :
												"0.95:1"
										}
									</div>
									<Chips {...commonChipProps} betKey={`banker+banker`} />
									<Tooltip {...commonTooltipProps} bet={this.props.bets[`banker+banker`]} />
								</div>
							</div>
						</div>
					)
			)
		);
	}
}